import isEqual from 'lodash/isEqual';

import {
  SET_CLEAN_BASKET_EDIT_STATE_V3,
  HAS_BASKET_STATE_CHANGED_V3,
  CLEAR_EDITED_BASKET_V3,
} from 'lib/constants/v3Actions';

const initialState = {
  mealServings: {},
  mealOptions: {},
  isDirty: false,
};

const hasStateChanged = (state, updatedMealServings, updatedMealOptions) => {
  return !(
    isEqual(state.mealServings, updatedMealServings) &&
    isEqual(state.mealOptions, updatedMealOptions)
  );
};

export default (state = initialState, action) => {
  switch (action.type) {
    case HAS_BASKET_STATE_CHANGED_V3: {
      return {
        ...state,
        isDirty: hasStateChanged(state, action.mealServings, action.mealOptions),
      };
    }
    case SET_CLEAN_BASKET_EDIT_STATE_V3: {
      return {
        ...state,
        mealServings: action.mealServings,
        mealOptions: action.mealOptions,
        isDirty: false,
      };
    }
    case CLEAR_EDITED_BASKET_V3:
      return initialState;
    default:
      return state;
  }
};
